import { Host, h } from "@stencil/core";
export class CardContent {
    render() {
        return (h(Host, { key: '45545a634067cee8d1d28d05291d8cef0299d416', class: "bal-card-content" }, h("slot", { key: '2d647c7e9bc7a95f9aa0f0d0b16fec7f6eb3383c' })));
    }
    static get is() { return "bal-card-content"; }
}
